module.exports = __webpack_public_path__ + "media/images/recruit/section/bumon_sp-f8ba157e84e81f02f64edbc7553184fa.png";